import {
  CorrespondenceThreadRoute,
  CorrespondenceThreadSearchSchema,
  correspondenceQueryKeys,
} from "toptaal-shared"
import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import {
  createFileRoute,
  useParams,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import ScreenWrapper from "@/components/ScreenWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { can } from "@/utils/can"

export const Route = createFileRoute("/correspondentie/$threadId")({
  component: RouteComponent,
  validateSearch: CorrespondenceThreadSearchSchema,
  beforeLoad: async () => {
    return checkPermissions("read", "correspondence")
  },
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useCurrentUserSuspenseQuery()

  const { threadId: threadIdParam } = useParams({
    from: "/correspondentie/$threadId",
  })
  const search = useSearch({
    from: "/correspondentie/$threadId",
  })

  const entityType = search.entityType
  const entityId = search.entityId || 0
  const threadId = Number(threadIdParam)

  const canCreateCorrespondence =
    entityType === "Student"
      ? can("create", "studentCorrespondence")
      : entityType === "LessonGroup"
        ? can("create", "groupCorrespondence")
        : can("create", "projectCorrespondence")

  const handleNavigateBack = () => {
    router.navigate({
      to: "/correspondentie",
    })
  }

  return (
    <ScreenWrapper className="!px-0">
      <CorrespondenceThreadRoute
        threadId={threadId}
        entityType={entityType}
        entityId={entityId}
        user={user.data}
        correspondenceQueryKeys={correspondenceQueryKeys}
        onNavigateBack={handleNavigateBack}
        canCreateCorrespondence={canCreateCorrespondence}
      />
    </ScreenWrapper>
  )
}
